export default __webpack_public_path__ + "static/media/Montserrat-Medium.3a091734.ttf";